export default __webpack_public_path__ + "static/media/svg-4.32ed20af.svg";